import apiClient from "../api/client";
import {
  AddOnLinkRecord,
  MenuDropDownItem,
  MenuDropDownResponse
} from "../types/addontypes";

export const fetchMenuAddOnGroupMenuAddOnLinks = async (
  id: string
): Promise<AddOnLinkRecord[] | null> => {
  try {
    const response = await apiClient.get<any[]>(
      "/api/MenuAddOnGroupMenuAddOnLink/GetMenuAddOnGroupMenuAddOnLinksByMenuAddOnGroupId",
      {
        params: { id }
      }
    );

    return response.data.map(
      ({
        guid,
        menuAddOnGroupGuid,
        menuGuid,
        displayName,
        sortOrder,
        menuOptionName,
        optionImageName,
        startDate,
        endDate,
        active,
      }): AddOnLinkRecord => ({
        key: guid,
        menuAddOnGroupGuid,
        menuGuid,
        displayName,
        sortOrder,
        menuOptionName,
        optionImageName,
        startDate,
        endDate,
        active,
      })
    );
  } catch (error) {
    console.error("Error fetching menu add-on links:", error);
    return null;
  }
};

export const updateAddOnSortOrder = async (
  sortValues: any
): Promise<void> => {
  try {
    await apiClient.put(
      "/api/MenuAddOnGroupMenuAddOnLink/UpdateSortOrderForAddOns",
      sortValues
    );
  } catch (error) {
    console.error("Error updating sort order:", error);
    alert("Failed to update sort order. Please try again.");
  }
};

export const deleteAddOnLink = async (
  id: string
): Promise<number> => {
  try {
    const response = await apiClient.delete(
      "/api/MenuAddOnGroupMenuAddOnLink/DeleteMenuAddOnGroupMenuAddOnLink",
      {
        params: { id }
      }
    );
    return response.status;
  } catch (error) {
    console.error("Error deleting Add-On:", error);
    throw error;
  }
};

export const fetchMenuAddOnDropDown = async (): Promise<MenuDropDownItem[]> => {
  try {
    const response = await apiClient.get<MenuDropDownResponse[]>(
      "/api/Menu/MenuItemDropDown/"
    );

    return response.data.map(
      ({ guid, name, upc, imageName, itemType }): MenuDropDownItem => ({
        key: guid,
        name,
        upc,
        imageName,
        itemType,
      })
    );
  } catch (error) {
    console.error("Error fetching menu items for dropdown:", error);
    return [];
  }
};

export const addMenuAddOnLink = async (data: any): Promise<number> => {
  try {
    const response = await apiClient.post(
      "/api/MenuAddOnGroupMenuAddOnLink/AddMenuAddOnGroupMenuAddOnLink",
      data
    );
    return response.status;
  } catch (error) {
    console.error("Error adding menu add-on link:", error);
    throw error;
  }
};

export const updateMenuAddOnLink = async (
  data: any
): Promise<number> => {
  try {
    const response = await apiClient.put(
      "/api/MenuAddOnGroupMenuAddOnLink/UpdateMenuAddOnGroupMenuAddOnLink",
      data
    );
    return response.status;
  } catch (error) {
    console.error("Error updating menu add-on link:", error);
    throw error;
  }
};

export const createMenuAddOnGroup = (data: {
  Name: string;
  DisplayName: string;
  Active: boolean;
  CreatedBy: string;
}) =>
  apiClient.post(
    "/api/MenuAddOnGroup/AddMenuAddOnGroup",
    data
  );

export const updateMenuAddOnGroup = (data: {
  Guid: string;
  Name: string;
  DisplayName: string;
  Active: boolean;
}) =>
  apiClient.put(
    "/api/MenuAddOnGroup/UpdateMenuAddOnGroup",
    data
  );

export const getMenuAddOnGroups = async () => {
  const res = await apiClient.get("/api/MenuAddOnGroup/");
  return res.data;
};

export const getMenuAddOnGroupById = async (id: string) => {
  const res = await apiClient.get(`/api/MenuAddOnGroup/${id}`);
  return res.data;
};

export const getMenuItemsForAddOnGroup = async (id: string) => {
  const res = await apiClient.get(
    "/api/MenuAddOnGroup/GetMenuItemsAssociatedToMenuAddOnGroup",
    {
      params: { id },
    }
  );

  return res.data;
};

export const getMenuAddOnsForMenu = async (menuItemGuid: string | null) => {
  const res = await apiClient.get(
    "/api/MenuAddOnGroup/GetMenuAddOnsForMenubyId",
    {
      params: { Id: menuItemGuid },
    }
  );
  return res.data;
};

export const getAllMenuAddOnGroups = async () => {
  const res = await apiClient.get("/api/MenuAddOnGroup");
  return res.data;
};

export const addMenuItemAddOnGroup = async (payload: {
  menuItemId: string;
  menuAddOnGroupGuid: string;
  createdByGuid: string;
}) => {
  return apiClient.post(
    "/api/MenuAddOnGroup/AddMenuItemMenuAddOnGroup",
    payload
  );
};

export const removeMenuItemAddOnGroup = async (payload: {
  menuItemId: string;
  menuAddOnGroupGuid: string;
}) => {
  return apiClient.post(
    "/api/MenuAddOnGroup/RemoveMenuItemMenuAddOnGroup",
    payload
  );
};

export const updateMenuAddOnGroupSortOrder = async (payload: {
  menuItemId: string | null;
  menuAddOnGroupGuids: string[];
}) => {
  return apiClient.post(
    "/api/MenuAddOnGroup/UpdateSortOrder",
    payload
  );
};
